import React from 'react';

const AnimatedBackground = () => {
  return (
    <div className="animated-background">
      <div className="floating-shapes">
        <div className="shape shape-1"></div>
        <div className="shape shape-2"></div>
        <div className="shape shape-3"></div>
        <div className="shape shape-4"></div>
        <div className="shape shape-5"></div>
        <div className="shape shape-6"></div>
      </div>
    </div>
  );
};

export default AnimatedBackground;
